export const environment = {
  production: false,
  serverURL: 'https://uat-api.codecraftlearning.in/api',
  wsUrl: 'wss://uat-api.codecraftlearning.in',
  version: '/v1',
  appName: 'Code Craft Learning Platform - UAT',
  paymentEnv: 'sandbox',
  googleClientId: '770678064720-qslut1eu2jb6ruvakbctto8qp477s904.apps.googleusercontent.com'
};
